import { useAuth } from 'oidc-react';
import { useCallback, useContext } from 'react';
import { useNavigate } from 'react-router';
import { LoadingContext } from '../utils';
import { request } from '../utils/request';
import useSelectedCustomer from './useSelectedCustomer';

const dsbLayerUrl = import.meta.env.VITE_DSBLAYERURL;
export default function useFetcher() {
  const navigate = useNavigate();
  const selectedCustomer = useSelectedCustomer();
  const auth = useAuth();

  const { setIsLoading } = useContext(LoadingContext);

  return useCallback(
    async function <T>(url: string): Promise<T> {
      setIsLoading(true);
      try {
        return await request<T>(`${dsbLayerUrl}/${selectedCustomer?.seoTitle}${url}`, {
          token: auth.userData?.access_token,
          onUnauthorized: () => navigate('/unauthorized'),
        });
      } finally {
        setIsLoading(false);
      }
    },
    [selectedCustomer, navigate, auth],
  );
}
